import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AInsteinPage from './pages/AInsteinPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

const AInsteinRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<AInsteinPage />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
    </Routes>
  );
};

export default AInsteinRoutes;
